/* eslint-disable arrow-parens */
/* eslint-disable comma-dangle */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-dracula';

import { Container } from './styles';
import api from '~/services/api';

export default function Feedback() {
  const [scorecard, setScorecard] = useState('');
  const [challenge, setChallenge] = useState('');
  const { id } = useParams();

  useEffect(() => {
    async function getData() {
      const { data } = await api.get(`scorecards/${id}`);

      setScorecard(data);
      setChallenge(data.challenge);
    }

    getData();
  }, [id]);

  return (
    <>
      <p
        style={{
          fontSize: 26,
          paddingLeft: 40,
          paddingTop: 30,
          color: '#36DED6',
          fontWeight: 'bold',
        }}
      >
        SUA RESPOSTA
      </p>
      <Container>
        <p>Desafio: {challenge.title}</p>
        <p>Pergunta: {challenge.question}</p>
        {/* {challenge.description ? (
          <p>Descriçāo: {challenge.description}</p>
        ) : null}
        {challenge.link_question ? (
          <p>Link: {challenge.link_question}</p>
        ) : null} */}

        <div className="answer">
          <h1>Sua Resposta:</h1>
          {challenge.type === 'code' ? (
            <AceEditor
              placeholder="Placeholder Text"
              mode={`${challenge.language}`}
              theme="dracula"
              name="blah2"
              fontSize={14}
              showPrintMargin
              showGutter
              highlightActiveLine
              value={
                scorecard.code_answer === null
                  ? 'Nāo foi possível carregar o script.'
                  : scorecard.code_answer
              }
              width="800px"
              height="300px"
            />
          ) : (
            <p>{scorecard.link_answer}</p>
          )}
        </div>

        <div className="feedback">
          <h1>Feedback:</h1>
          {scorecard.feedback ? (
            <p>{scorecard.feedback}</p>
          ) : (
            <p>Parabéns pela resposta!</p>
          )}
        </div>
      </Container>
    </>
  );
}
